module.exports = __webpack_public_path__ + "static/media/facebook-dark.6855f6b7.svg";